import React from 'react';
import { Router, Route,Routes, Switch,Redirect } from "react-router-dom";
import { connect } from 'react-redux';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { history } from './components/helpers/History';
import { USER_ROLE } from './components/security/UserRole';


import { BackDropActions } from './redux/actions/BackDropActions';
import { AlertActions } from './redux/actions/AlertActions';
import { UserActions } from './redux/actions/UserActions';

import theme from './components/theme/ThemeProvider'
import AlertMsg from './components/alert/AlertMsg'
import {PrivateRoute} from './components/PrivateRoute';
import BackdropLoader from './components/backdrop/BackDrop'
import GlobalStyle from './components/GlobalStyles';

import { LoginPage } from './pages/LoginPage';
import {SessionExpired} from './pages/SessionExpired';

import  PatientHomePage  from './pages/home/PatientHomePage';
import ForgetPassword from './pages/ForgetPassword';
import PatientSignUp from './pages/registration/PatientSignUp';
import UserProfile from './pages/patient/profile/PatientProfile';

import ChangePassword from './pages/ChangePassword';
import UpdatePassword from './pages/UpdatePassword';
import AdminList from './pages/admin/AdminList';
import AdminRegistration from './pages/registration/AdminRegistration';
import AdminProfile from './pages/admin/AdminProfile';
import DoctorPageList from './pages/doctor/DoctorList';
import DoctorRegistration from './pages/registration/DoctorRegistration';
import DoctorProfile from './pages/doctor/DoctorProfile';
import PatientList from './pages/patient/PatientList';
import PatientProfile from './pages/patient/profile/PatientProfile';
import BookAppointment from './pages/appointments/BookAppointment';
import TodayAppointmentHistory from './pages/appointments/TodayAppointmentHistory';
import PastAppointmentHistory from './pages/appointments/PastAppointmentHistory';
import FutureAppointmentHistory from './pages/appointments/FutureAppointmentHistory';
import EditAppointment from './pages/appointments/EditAppointment';
import ConfirmationPendingAppointment from './pages/appointments/ConfirmationPendingAppointment';
import AllAppointmentsCalendar from './pages/appointments/AllAppointmentsCalendar';
import WeeklyAppointmentHistory from './pages/appointments/WeeklyAppointmentHistory';
import TomorrowAppointmentHistory from './pages/appointments/TomorrowAppointmentHistory';
import BlockDoctorTime from './pages/appointments/BlockDoctorTime';
import SecretQuestion from './pages/SecretQuestion';


import QrCodeScanner from './components/qrcode/QrCodeScanner';
import QrCodeGenerator from './components/qrcode/QrCodeGenerator';




import AdminHomePage from './pages/home/AdminHomePage';
import DoctorHomePage from './pages/home/DoctorHomePage';
import HCPAdminList from './pages/admin/HCPAdminList';
import HCPAdminRegistration from './pages/registration/HCPAdminRegistration';
import DynamicFormList from './pages/dyanmicform/DynamicFormList';
import DynamicForm from './components/dynamicform/DynamicForm';
import DynamicFormInput from './components/dynamicform/DynamicFormInput';
import AssignDocument from './components/document/AssignDocument';
import DocumentList from './components/document/DocumentList';
import DocumentDynamicForm from './components/document/DocumentDynamicForm';
import PendingDocumentList from './components/document/PendingDocumentList';
import ViewDocument from './components/document/ViewDocument';
import SendSMSTOPatient from './components/sms/SendSMSTOPatient';





class App extends React.Component {
    constructor(props) {
        super(props);
        UserActions.verifyUser();
        history.listen((location, action) => {
            this.props.clearAlerts();
            setTimeout(() => {
                console.log(JSON.stringify(this.props));
                this.props.endBackDrop();
              }, 400);
            
        });
    }

    render() {
        return (
            <MuiThemeProvider theme={theme}>
                <GlobalStyle></GlobalStyle>
                <AlertMsg/>
                <BackdropLoader/>
                <Router history={history}>
                    <Switch>
                        
                        
                        
                        
                        
                        <PrivateRoute exact path="/" component={PatientHomePage} authorized={[USER_ROLE.PATIENT]}/>
                        <PrivateRoute exact path="/profile" component={UserProfile}  authorized={[USER_ROLE.SYSTEM_ADMIN,USER_ROLE.DOCTOR,USER_ROLE.HCP_ADMIN,USER_ROLE.PATIENT]}/>
                        <PrivateRoute exact path="/home" component={PatientHomePage}  authorized={[USER_ROLE.SYSTEM_ADMIN,USER_ROLE.DOCTOR,USER_ROLE.HCP_ADMIN,USER_ROLE.PATIENT]} />
                        <PrivateRoute exact path="/change-password" component={ChangePassword}  authorized={[USER_ROLE.SYSTEM_ADMIN,USER_ROLE.DOCTOR,USER_ROLE.HCP_ADMIN,USER_ROLE.PATIENT]} />
                        <PrivateRoute exact path="/change-password/:userid" component={UpdatePassword}  authorized={[USER_ROLE.SYSTEM_ADMIN,USER_ROLE.HCP_ADMIN]} />
                        <PrivateRoute exact path="/qrcode/:appointmentId" component={QrCodeGenerator}  authorized={[USER_ROLE.PATIENT]} />
                        
                        
                        
                        
                        
                        <PrivateRoute exact path="/documents" component={DocumentList}  authorized={[USER_ROLE.SYSTEM_ADMIN,USER_ROLE.DOCTOR,USER_ROLE.HCP_ADMIN,USER_ROLE.PATIENT]} />
                        <PrivateRoute exact path="/admin/home" component={AdminHomePage}  authorized={[USER_ROLE.SYSTEM_ADMIN,USER_ROLE.DOCTOR,USER_ROLE.HCP_ADMIN,USER_ROLE.PATIENT]} />
                        <PrivateRoute exact path="/admin" component={AdminList}  authorized={[USER_ROLE.SYSTEM_ADMIN,USER_ROLE.DOCTOR,USER_ROLE.HCP_ADMIN,USER_ROLE.PATIENT]} />
                        <PrivateRoute exact path="/admin/add" component={AdminRegistration}  authorized={[USER_ROLE.SYSTEM_ADMIN,USER_ROLE.DOCTOR,USER_ROLE.HCP_ADMIN,USER_ROLE.PATIENT]} /> <PrivateRoute exact path="/admin/add" component={AdminRegistration}  authorized={[USER_ROLE.SYSTEM_ADMIN,USER_ROLE.DOCTOR,USER_ROLE.HCP_ADMIN,USER_ROLE.PATIENT]} />
                        <PrivateRoute exact path="/admin/profile" component={AdminProfile}  authorized={[USER_ROLE.SYSTEM_ADMIN,USER_ROLE.DOCTOR,USER_ROLE.HCP_ADMIN,USER_ROLE.PATIENT]} />
                        <PrivateRoute exact path="/admin/edit/:userid" component={AdminProfile}  authorized={[USER_ROLE.SYSTEM_ADMIN,USER_ROLE.DOCTOR,USER_ROLE.HCP_ADMIN,USER_ROLE.PATIENT]} />
                        <PrivateRoute exact path="/admin/dynamicform" component={DynamicFormList}   authorized={[USER_ROLE.SYSTEM_ADMIN]} />
                        <PrivateRoute exact path="/admin/dynamicform/new" component={DynamicForm}   authorized={[USER_ROLE.SYSTEM_ADMIN]} />
                        <PrivateRoute exact path="/admin/dynamicform/:formid" component={DynamicForm}   authorized={[USER_ROLE.SYSTEM_ADMIN]} />
                        <PrivateRoute exact path="/admin/dynamicform/view/:formid" component={DynamicFormInput}   authorized={[USER_ROLE.SYSTEM_ADMIN]} />
                       
                        <PrivateRoute exact path="/admin/hcp" component={HCPAdminList}  authorized={[USER_ROLE.SYSTEM_ADMIN,USER_ROLE.DOCTOR,USER_ROLE.HCP_ADMIN,USER_ROLE.PATIENT]} />
                        <PrivateRoute exact path="/admin/hcp/add" component={HCPAdminRegistration}  authorized={[USER_ROLE.SYSTEM_ADMIN,USER_ROLE.DOCTOR,USER_ROLE.HCP_ADMIN,USER_ROLE.PATIENT]} />
                        
                        <PrivateRoute exact path="/doctor" component={DoctorPageList}  authorized={[USER_ROLE.SYSTEM_ADMIN,USER_ROLE.DOCTOR,USER_ROLE.HCP_ADMIN,USER_ROLE.PATIENT]} />
                        <PrivateRoute exact path="/doctor/home" component={DoctorHomePage}  authorized={[USER_ROLE.SYSTEM_ADMIN,USER_ROLE.DOCTOR,USER_ROLE.HCP_ADMIN,USER_ROLE.PATIENT]} />
                        <PrivateRoute exact path="/doctor/add" component={DoctorRegistration}  authorized={[USER_ROLE.SYSTEM_ADMIN,USER_ROLE.DOCTOR,USER_ROLE.HCP_ADMIN,USER_ROLE.PATIENT]} />
                        <PrivateRoute exact path="/doctor/edit/:userid" component={DoctorProfile}  authorized={[USER_ROLE.SYSTEM_ADMIN,USER_ROLE.DOCTOR,USER_ROLE.HCP_ADMIN,USER_ROLE.PATIENT]} />
                        <PrivateRoute exact path="/doctor/profile" component={DoctorProfile}  authorized={[USER_ROLE.SYSTEM_ADMIN,USER_ROLE.DOCTOR,USER_ROLE.HCP_ADMIN,USER_ROLE.PATIENT]} />
                        <PrivateRoute exact path="/patient" component={PatientList}  authorized={[USER_ROLE.SYSTEM_ADMIN,USER_ROLE.DOCTOR,USER_ROLE.HCP_ADMIN,USER_ROLE.PATIENT]} />
                        <PrivateRoute exact path="/patient/actionitems" component={PendingDocumentList}  authorized={[USER_ROLE.SYSTEM_ADMIN,USER_ROLE.DOCTOR,USER_ROLE.HCP_ADMIN,USER_ROLE.PATIENT]} />
                        
                        <PrivateRoute exact path="/patient/add" component={PatientProfile}  authorized={[USER_ROLE.SYSTEM_ADMIN,USER_ROLE.DOCTOR,USER_ROLE.HCP_ADMIN,USER_ROLE.PATIENT]} />
                        <PrivateRoute exact path="/patient/profile" component={AdminProfile}  authorized={[USER_ROLE.SYSTEM_ADMIN,USER_ROLE.DOCTOR,USER_ROLE.HCP_ADMIN,USER_ROLE.PATIENT]} />
                        <PrivateRoute exact path="/patient/edit/:userid" component={PatientProfile}  authorized={[USER_ROLE.SYSTEM_ADMIN,USER_ROLE.DOCTOR,USER_ROLE.HCP_ADMIN,USER_ROLE.PATIENT]} />
                        <PrivateRoute exact path="/appointments" component={TodayAppointmentHistory}  authorized={[USER_ROLE.SYSTEM_ADMIN,USER_ROLE.DOCTOR,USER_ROLE.HCP_ADMIN,USER_ROLE.PATIENT]} />
                        <PrivateRoute exact path="/appointments/new" component={BookAppointment}  authorized={[USER_ROLE.SYSTEM_ADMIN,USER_ROLE.DOCTOR,USER_ROLE.HCP_ADMIN,USER_ROLE.PATIENT]} />
                        <PrivateRoute exact path="/appointments/past" component={PastAppointmentHistory}  authorized={[USER_ROLE.SYSTEM_ADMIN,USER_ROLE.DOCTOR,USER_ROLE.HCP_ADMIN,USER_ROLE.PATIENT]} />
                        <PrivateRoute exact path="/appointments/future" component={FutureAppointmentHistory}  authorized={[USER_ROLE.SYSTEM_ADMIN,USER_ROLE.DOCTOR,USER_ROLE.HCP_ADMIN,USER_ROLE.PATIENT]} />
                        <PrivateRoute exact path="/appointments/weekly" component={WeeklyAppointmentHistory}  authorized={[USER_ROLE.SYSTEM_ADMIN,USER_ROLE.DOCTOR,USER_ROLE.HCP_ADMIN,USER_ROLE.PATIENT]} />
                        <PrivateRoute exact path="/appointments/tomorrow" component={TomorrowAppointmentHistory}  authorized={[USER_ROLE.SYSTEM_ADMIN,USER_ROLE.DOCTOR,USER_ROLE.HCP_ADMIN,USER_ROLE.PATIENT]} />
                        <PrivateRoute exact path="/appointments/edit/:appointmentId" component={EditAppointment}  authorized={[USER_ROLE.SYSTEM_ADMIN,USER_ROLE.DOCTOR,USER_ROLE.HCP_ADMIN,USER_ROLE.PATIENT]} />
                        <PrivateRoute exact path="/appointments/pending" component={ConfirmationPendingAppointment}  authorized={[USER_ROLE.SYSTEM_ADMIN,USER_ROLE.DOCTOR,USER_ROLE.HCP_ADMIN,USER_ROLE.PATIENT]} />
                        <PrivateRoute exact path="/appointments/calendar" component={AllAppointmentsCalendar}  authorized={[USER_ROLE.SYSTEM_ADMIN,USER_ROLE.DOCTOR,USER_ROLE.HCP_ADMIN,USER_ROLE.PATIENT]} />
                        <PrivateRoute exact path="/scanner" component={QrCodeScanner}  authorized={[USER_ROLE.SYSTEM_ADMIN,USER_ROLE.DOCTOR,USER_ROLE.HCP_ADMIN,USER_ROLE.PATIENT]} />
                        <PrivateRoute exact path="/doctor/block" component={BlockDoctorTime}  authorized={[USER_ROLE.SYSTEM_ADMIN,USER_ROLE.DOCTOR,USER_ROLE.HCP_ADMIN,USER_ROLE.PATIENT]} />
                        
                        <PrivateRoute exact path="/secretquestion" component={SecretQuestion}  authorized={[USER_ROLE.SYSTEM_ADMIN,USER_ROLE.DOCTOR,USER_ROLE.HCP_ADMIN,USER_ROLE.PATIENT]} />
                        <PrivateRoute exact path="/document/assign" component={AssignDocument}  authorized={[USER_ROLE.SYSTEM_ADMIN,USER_ROLE.DOCTOR,USER_ROLE.HCP_ADMIN,USER_ROLE.PATIENT]} />
                        <PrivateRoute exact path="/document/upload/:documentid" component={DocumentDynamicForm}  authorized={[USER_ROLE.SYSTEM_ADMIN,USER_ROLE.DOCTOR,USER_ROLE.HCP_ADMIN,USER_ROLE.PATIENT]} />
                        <PrivateRoute exact path="/document/view/:documentid" component={ViewDocument}  authorized={[USER_ROLE.SYSTEM_ADMIN,USER_ROLE.DOCTOR,USER_ROLE.HCP_ADMIN,USER_ROLE.PATIENT]} />
                        <PrivateRoute exact path="/admin/sms" component={SendSMSTOPatient}  authorized={[USER_ROLE.SYSTEM_ADMIN,USER_ROLE.DOCTOR,USER_ROLE.HCP_ADMIN]} />
                        
                        
                        
                        
                        
                        
                        
                        
                        <Route path="/login" component={LoginPage} />
                        <Route path="/forgetpwd" component={ForgetPassword} />
                        <Route path="/register" component={PatientSignUp} />
                        <Route path="/scanner/new" component={QrCodeScanner}/>
                        <Route path="/session-expired" component={SessionExpired} />
                        
                        
                        
                        <Redirect from="*" to="/" />
                    </Switch>
                </Router>
            </MuiThemeProvider>
        );
    }
}

function mapState(state) {
    
    return { state };
}

const actionCreators = {
    clearAlerts: AlertActions.clear,
    endBackDrop: BackDropActions.end,
};

export default connect(mapState, actionCreators)(App);
